export const iconFontAwesomeCommunicationAddressBook = (
	<i className="fa-solid fa-address-book"></i>
);
